( function( $ ) {
    //stel een vraag aan expert
    $( ".single-redacteur .expert-slide-content .btn" ).on('click', function( event ) {
        event.preventDefault();
        steleenvraag();
    } );

    //check voor parameter zodat gelijk formulier wordt getoond voor stel een vraag
    $.extend( {
        getUrlVars: function() {
            var vars = [], hash;
            var hashes = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );
            for( var i = 0; i < hashes.length; i++ )
            {
                hash = hashes[i].split( '=' );
                vars.push( hash[0] );
                vars[hash[0]] = hash[1];
            }
            return vars;
        },
        getUrlVar: function( name ){
            return $.getUrlVars()[name];
        }
    } );
    if ( $.getUrlVar( "stelvraag" ) != null ) {
        steleenvraag();
    }

    function steleenvraag() {
        $( ".expert-intro-mail" ).toggle();
        $( ".expert-intro-lead.expert_text" ).toggle();
        $( ".expert-intro-lead.expert_intro" ).toggle();
        $( ".vraagadvies" ).toggle();
        $( ".bekijkprofiel" ).toggle();
    }

    $( document ).ajaxComplete( function( event, xhr, options ) {
        if ( ( xhr.responseJSON !== undefined && xhr.responseJSON !== null ) && xhr.responseJSON.success && options.data !== undefined ) {
            var pairs = decodeURIComponent( options.data ).split( '&' );

            var result = {};
            pairs.forEach(function( pair ) {
                pair = pair.split( '=' );
                result[pair[0]] = decodeURIComponent( pair[1] || '' );
            } );

            var data = JSON.parse( JSON.stringify( result ) );

            if( data.action && data.action === "um_ajax_login" ) {

                if( data.formdata && data.formdata === 'expertlogin' ) {
                    var url = window.location.host + window.location.pathname + '?stelvraag=ja';
                    window.location.href = url;
                } else {
                    window.location.reload();
                }
            }
        }
    } );
} )( jQuery );
